import { render } from "./DocumentsTable.vue?vue&type=template&id=ac9703e2&scoped=true&ts=true"
import script from "./DocumentsTable.vue?vue&type=script&lang=ts"
export * from "./DocumentsTable.vue?vue&type=script&lang=ts"

import "./DocumentsTable.vue?vue&type=style&index=0&id=ac9703e2&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9703e2"]])

export default __exports__